import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post, Query, Req, Res, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { ApiConsumes, ApiHeader, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { AppointmentService } from './appointment.service';
import { AllAppointmentResponseModel, AppointmentResponseModel } from './appointment-response-module';
import { AppointmentDTO } from './dto/appointment.dto';

@ApiTags('Appointment')

@Controller('appointment')
export class AppointmentController {
    constructor (
        private AppService: AppointmentService,
    ){}

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/createAppointment') 
    @ApiQuery({name:'apiVersion'})   
    async createAppointment(@Query() queryParam,@Body() appDto:AppointmentDTO,@Req() request:Request): Promise<AppointmentResponseModel> {
        try {
            return await this.AppService.createAppointment(queryParam,appDto,request);
        } catch (error) {
            return errorHandler(AppointmentResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getAppointments/:userId')
    @ApiParam({name:'userId'})
    @ApiQuery({name:'apiVersion'})
    async getAppointments(@Query() queryParams, @Param('userId') userId, @Req() request:Request):Promise<AllAppointmentResponseModel> {
        try {           
            return await this.AppService.getAppointments(queryParams,userId,request);
        } catch (error) {
            return errorHandler(AllAppointmentResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getAppointmentById/:Id')
    @ApiParam({name:'Id'})
    @ApiQuery({name:'apiVersion'})
    async getAppointmentById(@Query() queryParams, @Param('Id') Id, @Req() request:Request):Promise<AppointmentResponseModel> {
        try {           
            return await this.AppService.getAppointmentById(queryParams,Id,request);
        } catch (error) {
            return errorHandler(AppointmentResponseModel, error);
        }
    }
    
    
}
